import React__default from 'react';
import { DEFAULT_GAP } from './constants.mjs';
import useTheme from '../../../../../../node_modules/@mui/material/styles/useTheme.mjs';

// Row container that will wrap according to width of the container
const FlexBox = ({ children, gap, alignItems, flexDirection, justifyContent, flexWrap })=>{
    const theme = useTheme();
    return /*#__PURE__*/ React__default.createElement("div", {
        style: {
            display: 'flex',
            gap: theme.spacing(gap ?? DEFAULT_GAP),
            alignItems,
            justifyContent,
            flexDirection,
            flexWrap
        }
    }, children);
};

export { FlexBox };
//# sourceMappingURL=FlexBox.mjs.map
